<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { axiosGetPost } from '@router/axiosGetPost'
import DuplicateLog from '@/src/components/request/DuplicateLog'
import WaitingStatus from '@/src/components/WaitingStatus'

export default {
  page: {
    title: 'Account Details',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, DuplicateLog, WaitingStatus },
  props: {
    user: {
      type: [Array, Object],
      default: function () {
        return {}
      },
    },
  },
  data() {
    return {
      title: 'Accounts Details',
      items: [
        {
          text: 'Barracuda',
          href: '/',
        },
        {
          text: 'Accounts LocalCharge',
          href: '/accounts/localchages',
        },
        {
          text: 'Details',
          active: true,
        },
      ],
      localcharge_id: this.$route.params.id,
      errors: [],
      validation: null,
      name: null,
      companyUser: null,
      status: null,
      date: null,
      loadingData: false,
      module: 'FCL',
      showModal: false,
      modalComponent: 'changeStatus',
      modalTitle: 'Status',
      modalError: null,
      modalErrorShow: false,
    }
  },
  watch: {
    // call again the method if the route changes
    $route: 'getData',
  },
  created() {
    this.getData()
  },
  methods: {
    redirectGoodAndFail() {
      this.$router.push({
        path: `/failure_review_localcharge/${this.localcharge_id}`,
      })
    },
    getData() {
      axiosGetPost(
        'get',
        'localCharges/account_data/' + this.localcharge_id,
        {},
        'Get data detail account Localcharge'
      ).then((response) => {
        this.name = response.name
        this.companyUser = response.company_user.name
        this.date = response.date
        this.status = response.status
      })
    },
    reImportContract() {
      axiosGetPost(
        'GET',
        '/localCharges/reimport/' + this.localcharge_id,
        {},
        'Reimport Localcharge'
      ).then((response) => {
        console.log(response)
        let data = response.data
        this.modalTitle = 'Waiting...'
        this.modalComponent = 'WaitingStatus'
        this.showModal = true
        this.loadingData = false
        return data
      })
    },
    downloadFile(id) {
      axiosGetPost(
        'get',
        '/localCharges/downloadF/' + id,
        {},
        'Download File Account Localcharges detail'
      ).then((response) => {
        if (response.success === true) {
          var link = document.createElement('a')
          link.setAttribute('target', '_blank')
          link.href = response.url
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          this.$toastr.e(
            'Error Download. Status code: ' +
              data.status +
              ' Error: ' +
              data.error
          )
        }
        return data
      })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <form action>
            <div class="card-body">
              <h4 class="header-title mb-3 mt-0">
                Account Detail / Request: {{ localcharge_id }} -
                <span class="badge">Importation</span>
              </h4>
              <div v-if="loadingData === false">
                <div class="form-group">
                  <div class="row">
                    <div class="col-md col-md-4">
                      <label for="name"> Reference </label>
                      <b-form-input
                        id="name"
                        v-model="name"
                        value
                        placeholder="Write name"
                        readonly
                      ></b-form-input>
                    </div>
                    <div class="col-md col-md-2">
                      <label for="name"> Date </label>
                      <b-form-input
                        id="name"
                        v-model="date"
                        value
                        placeholder="Write name"
                        readonly
                      ></b-form-input>
                    </div>
                    <div class="col-md col-md-2">
                      <label for="name"> Company User </label>
                      <b-form-input
                        id="name"
                        v-model="companyUser"
                        value
                        placeholder="Write name"
                        readonly
                      >
                      </b-form-input>
                    </div>
                    <div class="col-md col-md-2">
                      <label for="name" style="text-decoration: underline red">
                        <i></i> Status Contract
                      </label>
                      <b-form-input
                        id="name"
                        v-model="status"
                        value
                        placeholder="Write name"
                        readonly
                      >
                      </b-form-input>
                    </div>
                  </div>
                </div>
                <hr />
                <br />
                <div class="form-group">
                  <div class="button-list">
                    <b-button
                      :to="{
                        name: 'localcharges_import',
                        params: {
                          id: localcharge_id,
                        },
                      }"
                      class="col-2"
                      variant="primary"
                      >Import With File
                    </b-button>
                    <b-button
                      class="col-2"
                      variant="success"
                      @click="reImportContract"
                      >Reimport</b-button
                    >
                    <b-button
                      class="col-2"
                      @click="downloadFile(localcharge_id)"
                      variant="info"
                    >
                      Download File
                    </b-button>

                    <b-button
                      :to="{
                        name: 'goodandfails_localcharge',
                        params: {
                          id: localcharge_id,
                        },
                      }"
                      class="col-2"
                      variant="warning"
                      >Good and Fail</b-button
                    >
                  </div>
                  <div class="row">
                    <!--<div class="col-md col-md-2">
                    </div>-->
                    <div class="col-md col-md-5">
                      <div class="form-group row">
                        <div class="col-sm-7"> </div>
                        <div class="col-md-4"> </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-5 col-sm-5"></div>
                    <div class="col-xl-2 col-sm-2">
                      <div class="form-group mt-1 mt-sm-0"> </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="loadingData"
                  class="row align-items-center justify-content-center"
                  style="height: 300px"
                >
                  <div class="col-12 col-md-8 text-center">
                    <b-spinner
                      label="Loading..."
                      variant="secondary"
                      class="ml-3"
                    ></b-spinner>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <b-modal
        id="modal-lg"
        ref="requestFcl"
        v-model="showModal"
        size="lg"
        :title="modalTitle"
        title-class="font-18"
      >
        <div
          v-if="loadingData"
          class="row align-items-center justify-content-center"
          style="height: 300px"
        >
          <div class="col-12 col-md-8 text-center">
            <b-spinner
              label="Loading..."
              variant="primary"
              class="ml-3"
            ></b-spinner>
          </div>
        </div>

        <div v-else-if="modalErrorShow === true">
          <div
            class="row align-items-center justify-content-center"
            style="height: 300px"
          >
            <div class="col-12 col-md-8 text-center">
              <feather type="frown" class="icon-xxl icon-dual-info"></feather>
              <h6 class="text-muted">{{ modalError }}</h6>
            </div>
          </div>
        </div>

        <WaitingStatus
          v-else-if="modalComponent === 'WaitingStatus'"
          :request-id="localcharge_id"
          :reload-time="10"
          @postevent="redirectGoodAndFail"
          has-post-event
          url="/localCharges/getStatusTask/"
        />
        <template v-slot:modal-footer>
          <b-button variant="light" @click="$refs.requestFcl.hide"
            >Close</b-button
          >
        </template>
      </b-modal>
    </div>
  </Layout>
</template>
<style>
.DRY {
  color: blue;
}
</style>